import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicFieldDropdown, BaasicButton, BaasicDropdown, BaasicDraggableModal, BasicInput } from "core/components";
import { observer } from "mobx-react";
import { NikoPatientTemplateItemCalculationModal } from "application/niko-patient/components";

function NikoFacilityOrderNewFlowExtraSuppliesAddModalTemplate({ nikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore, t }) {
    const {
        form,
        subCategoryStore,
        clinicalStatusStore,
        modalParams,
        patientTemplateItems,
        patientTemplateTrachItems,
        nikoPatientTemplateItemCalculationModal,
        sendAgoraPo
    } = nikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Add Extra Supplies</h3>
            </div>
            <div className="modal__body">
                <div className="row">
                    <div className="form__group col col-med-3">
                        <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} />
                    </div>
                    <div className="form__group col col-med-3">
                        <BaasicFieldDropdown field={form.$('clinicalStatusId')} store={clinicalStatusStore} />
                    </div>
                    {sendAgoraPo === false &&
                        <div className="form__group col col-med-6">
                            <BasicInput field={form.$('invoiceNote')} />
                        </div>
                    }
                </div>
                <div className="table--tertiary__wrapper u-mar--bottom--sml">
                    <TemplateItemsTable facilityOrderTemplateNewFlowCreateViewStore={nikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore} patientTemplateItems={patientTemplateItems} />
                </div>
                {patientTemplateTrachItems.length > 0 &&
                    <div className="table--tertiary__wrapper">
                        <TemplateItemsTable facilityOrderTemplateNewFlowCreateViewStore={nikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore} patientTemplateItems={patientTemplateTrachItems} />
                    </div>
                }
                <BaasicDraggableModal modalParams={nikoPatientTemplateItemCalculationModal} className="modal__content modal--lrg">
                    <NikoPatientTemplateItemCalculationModal />
                </BaasicDraggableModal>
            </div>
            <div className='modal__footer is-right'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                    disabled={form.submitting || form.validating}
                />
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Create"
                    className='btn btn--med btn--primary'
                />
            </div>
        </section>
    )
}

const TemplateItemsTable = observer(({ facilityOrderTemplateNewFlowCreateViewStore, patientTemplateItems }) => {
    const {
        // facilityOrderTemplateTrachItems,
        productStore,
        itemCategory,
        saveItem,
        editItem,
        deleteItem,
        // openFacilityOrderTemplateItemNewFlowCalculationModal
    } = facilityOrderTemplateNewFlowCreateViewStore;

    const productDropdownItemRender = (li, itemProps) => {
        const itemName = itemProps && itemProps.dataItem.description;
        const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && itemCategory === "ostomy" ?
            <i className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i> : null;
        const isBackorderedIcon = itemProps && itemProps.dataItem.backordered ? <i className="u-icon u-icon--sml u-icon--backordered u-mar--left--tny"></i> : null;
        const nonBillableIcon = itemProps && !itemProps.dataItem.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--non-billable u-mar--left--tny"></i> : null;
        const itemChildren = (
            <span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
                <span style={{ flex: "1" }}> {li.props.children} </span>
                <span style={{ fontSize: "12px" }}> {isPreferredIcon} {itemName} {nonBillableIcon} {isBackorderedIcon}</span>
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    // const isEnteral = itemCategory === "enteral" && facilityOrderTemplateItems !== facilityOrderTemplateTrachItems;

    return (
        <table className="table table--tertiary">
            <colgroup>
                <col width="225" />
                <col width="200" />
                <col width="90" />
                <col width="70" />
                <col width="200" />
                <col width="70" />
            </colgroup>
            <thead>
                <tr>
                    <th>Item Id</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>SO QTY</th>
                    <th>NOTE</th>
                    <th className="type--right">Actions</th>
                </tr>
            </thead>
            <tbody>
                {patientTemplateItems.map((item, index) => {
                    // var isFormula = (item && item.product && item.product.itemType && (item.product.itemType.abrv === 'bottle' || item.product.itemType.abrv === 'can')) || (item.product && item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155");
                    return (
                        <tr key={item.id}>
                            <td>
                                {
                                    item.product ? item.product.itemId :
                                        <BaasicDropdown
                                            placeholder="Select an ID..."
                                            store={productStore}
                                            value={item.product}
                                            itemRender={productDropdownItemRender}
                                            onChange={(e) => { saveItem(patientTemplateItems, index, e.target.value); }}
                                        />
                                }
                            </td>
                            <td className='is-flex'>
                                {item.product && item.product.description} <span className="table__icons-wrapper"> {item.product && !item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>} {(item.isBackordered != null ? item.isBackordered : item.product && item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span>
                            </td>
                            <td>
                                {item.product && item.product.uoM}
                            </td>
                            <td className="table-col-input text-align-left">
                                <input
                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                    onClick={(e) => e.target.select()}
                                    onChange={(e) => {
                                        editItem(patientTemplateItems, index, e.target.value, 'salesOrderQuantity')
                                    }}
                                    value={item.salesOrderQuantity}
                                    type="number"
                                    min="0"
                                />
                            </td>
                            <td>
                                <input
                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                    onClick={(e) => e.target.select()}
                                    onChange={(e) => { item.note = e.target.value }}
                                    value={item.note}
                                />
                            </td>
                            <td className="type--right">
                                <div className="table__icons">
                                    {
                                        item.product &&
                                        <BaasicButton
                                            className="btn btn--icon"
                                            icon="u-icon u-icon--delete--primary u-icon--sml"
                                            label="Delete"
                                            onlyIcon={true}
                                            onClick={() => deleteItem(patientTemplateItems, index)}
                                        ></BaasicButton>
                                    }
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
});

TemplateItemsTable.propTypes = {
    facilityOrderTemplateNewFlowCreateViewStore: PropTypes.object.isRequired,
    patientTemplateItems: PropTypes.object.isRequired
};

NikoFacilityOrderNewFlowExtraSuppliesAddModalTemplate.propTypes = {
    nikoFacilityOrderNewFlowExtraSuppliesAddModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoFacilityOrderNewFlowExtraSuppliesAddModalTemplate);